import PropTypes from 'prop-types'
import React from 'react'
import { getPriceTypeTitle, getFormatDate } from '../../../functions/functions'
import { getAdThumbnailUrl } from 'SRC/modules/ads/shared/functions'
import { Image } from '../../Item/Image'
import Link from 'next/link'
import { MarkSold, TogglePause, Refresh, Promote, AutoRefresh } from '../Buttons'
import { adsStatues } from '../../../../shared/constants'
import { Preloader } from 'SRC/ui/Preloader'
import { listingStatuses } from 'SRC/modules/ads/lisitings/constants'
import { getFormattedAdPrice } from 'SRC/utils'

export class Item extends React.PureComponent {
  refreshPeriodInHours = 48

  constructor (props) {
    super(props)

    this.state = {secondsToRefresh: this.getSecondsToRefresh()}
  }

  componentDidMount () {
    if (this.state.secondsToRefresh > 0) {
      this.createCounter()
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.refreshed && (!prevProps.refreshed || this.props.refreshed !== prevProps.refreshed)) {
      this.createCounter()
    }
  }

  componentWillUnmount () {
    if (this.counter) {
      clearInterval(this.counter)
    }
  }

  createCounter = () => {
    if (this.getButtonsStatusByAdsStatus(this.props.status).refresh) {
      this.counter = setInterval(() => {
        this.setState({...this.state, secondsToRefresh: this.getSecondsToRefresh()})
      }, 1000)
    }
  }

  getButtonsStatusByAdsStatus = adStatus => {
    const buttonsStatus = {}
    switch (adStatus) {
      case adsStatues.PUBLISHED.code:
        buttonsStatus.markSold = true
        buttonsStatus.refresh = true
        buttonsStatus.togglePause = true
        buttonsStatus.promote = true
        break
      case adsStatues.UNPUBLISHED.code:
        buttonsStatus.markSold = true
        buttonsStatus.refresh = false
        buttonsStatus.togglePause = false
        buttonsStatus.promote = true
        break
      case adsStatues.SOLD.code:
        buttonsStatus.markSold = false
        buttonsStatus.promote = false
        buttonsStatus.refresh = false
        buttonsStatus.togglePause = false
        break
      case adsStatues.REJECTED.code:
        buttonsStatus.markSold = false
        buttonsStatus.refresh = false
        buttonsStatus.togglePause = false
        buttonsStatus.promote = false
        break
      case adsStatues.EXPIRED.code:
        buttonsStatus.markSold = true
        buttonsStatus.refresh = true
        buttonsStatus.togglePause = false
        buttonsStatus.promote = false
        break
      case adsStatues.PAUSED.code:
        buttonsStatus.markSold = true
        buttonsStatus.togglePause = true
        buttonsStatus.promote = false
        buttonsStatus.refresh = true
        break
    }
    return buttonsStatus
  }

  getSecondsToRefresh = () => {
    if (this.props.refreshed) {
      const refreshed = new Date(this.props.refreshed)
      refreshed.setHours(refreshed.getHours() + this.refreshPeriodInHours)
      const current = new Date()
      const diff = refreshed.getTime() - current.getTime()
      if (diff > 0) {
        return Math.ceil(diff / 1000)
      }
      return 0
    }
    return 0
  }

  getTimeToRefresh = seconds => {
    const hoursCount = Math.trunc(seconds / (60 * 60))
    const hoursInSeconds = hoursCount * 60 * 60
    const minutesCount = Math.trunc((seconds - hoursInSeconds) / 60)
    const minutesInSeconds = minutesCount * 60
    const secondsCount = seconds - hoursInSeconds - minutesInSeconds
    return `${hoursCount}h ${minutesCount}m ${secondsCount}s`
  }

  isListingStatusAllowedPromote = () =>
    !this.props.listingStatus ||
    this.props.listingStatus === listingStatuses.EXPIRED ||
    this.props.listingStatus === listingStatuses.REJECTED

  renderPrice = () => {
    const {
      price,
      oldPrice,
      priceFrom,
      priceTo,
      priceDaily,
      priceMonthly,
      priceSpecification,
      isBuying
    } = this.props

    console.log('priceSpecification', priceSpecification)

    if (priceSpecification === 0) {
      return null
    }

    if (typeof priceSpecification === 'object' && priceSpecification !== null && typeof priceSpecification.value !== 'undefined') {
      return (
        <div className='cena'>
          <p>{`${priceSpecification.value} ${priceSpecification.measure || ''}`}</p>
        </div>
      )
    }

    const isRent = (priceDaily || priceMonthly) && (!price && !priceFrom)

    if (priceFrom && priceTo) {
      return (
        <div className='cena'>
          <p>{getFormattedAdPrice(priceFrom)} do {getFormattedAdPrice(priceTo)} &euro;</p>
        </div>
      )
    } else if (priceFrom && !priceTo) {
      return (
        <div className='cena' key='priceFrom'>
          <p>Već od {getFormattedAdPrice(priceFrom)} &euro;</p>
        </div>
      )
    } else if (!priceFrom && priceTo) {
      return (
        <div className='cena' key='priceTo'>
          <p>Do {getFormattedAdPrice(priceTo)} &euro;</p>
        </div>
      )
    } else if (isRent) {
      return <React.Fragment>
        {priceMonthly ? <div className='cena'>
          <p>{getFormattedAdPrice(priceMonthly)} &euro; mjesec</p>
        </div> : null}
        {priceDaily ? <div className='cena'>
          <p>{getFormattedAdPrice(priceDaily)} &euro; dan</p>
        </div> : null}
      </React.Fragment>
    } else {
      return (
        <React.Fragment>
          {price
            ? (
              <div className='cena'>
                <p>{`${isBuying ? 'do ' : ''}${getFormattedAdPrice(price)}`} &euro;</p>
              </div>
            ) : <div className='cena'>Po dogovoru</div>
          }
          {
            oldPrice
              ? <div className='cena-akcija'>
                <p>{getFormattedAdPrice(oldPrice)} &euro;</p>
              </div>
              : null
          }
        </React.Fragment>
      )
    }
  }

  renderPriceType = () => {
    const { priceType, priceOnRequest, priceSpecification } = this.props

    if (priceSpecification === 0 || priceSpecification !== null) return null

    const priceTypeTitle = getPriceTypeTitle(priceType)

    if (priceTypeTitle && !priceOnRequest) {
      return <div className='vrsta-cene'>
        <p>{priceTypeTitle}</p>
      </div>
    }
  }

  render () {
    const img = getAdThumbnailUrl({ thumbnail: this.props.thumbnail, media: this.props.media })
    const title = this.props.titleCompiled || ''
    const priceOnRequest = this.props.priceOnRequest
    const date = getFormatDate(this.props.createdAt)
    const isPaid = Boolean(this.props.isPaid)
    const categorySeo = this.props.category && this.props.category.seo ? this.props.category.seo : ''
    const categoryTitle = this.props.category && this.props.category.title ? this.props.category.title : ''

    // const views = Array.isArray(this.props.views)
    //   ? this.props.views[0] && this.props.views[0].count
    //   : this.props.views ? Number(this.props.views) : 0

    let payedTo = null
    if (isPaid && this.props.listingActivated && this.props.listing && Number(this.props.listing.duration)) {
      let listingActivated = new Date(this.props.listingActivated)
      listingActivated.setDate(listingActivated.getDate() + this.props.listing.duration)
      payedTo = getFormatDate(listingActivated.toISOString())
    }
    const buttonsStatuses = this.getButtonsStatusByAdsStatus(this.props.status)

    const parentCategorySeo = this.props.parentCategories && this.props.parentCategories.length
      ? this.props.parentCategories[0].seo : null

    let hrefUrl = `/ad?parentCategory=${parentCategorySeo}&category=${this.props.category.seo}&ad=${this.props.seo}`
    let asUrl = `/${parentCategorySeo}/${this.props.category.seo}/${this.props.seo}`

    if (parentCategorySeo === this.props.category.seo) {
      hrefUrl = `/ad?parentCategory=${parentCategorySeo}&ad=${this.props.seo}`
      asUrl = `/${parentCategorySeo}/${this.props.seo}`
    }

    let titleFormatted = title

    if (titleFormatted.length >= 50) {
      titleFormatted = `${titleFormatted.substring(0, 49)}...`
    }

    return (
      <div className={`moji-oglasi-item ${isPaid ? `moji-oglasi-placen-oglas` : ``}`}>
        <Image
          className='moji-oglasi-item-img'
          category={categorySeo}
          seo={this.props.seo}
          hrefUrl={hrefUrl}
          asUrl={asUrl}
          payed={this.props.isPaid}
          status={this.props.status}
          img={img}
          tip={title}
        />
        <div className='moji-oglasi-item-content'>
          <div className='moji-oglasi-item-content-main'>
            <div className='moji-oglasi-item-content-info'>
              <Link href={hrefUrl} as={asUrl}>
                <a className='moji-oglasi-item-heading'>{titleFormatted}</a>
              </Link>
              <p>Kategorija: {categoryTitle}</p>
              <p>Šifra oglasa: {this.props.code}</p>

              {!priceOnRequest
                ? [this.renderPrice(), this.renderPriceType()]
                : <div className='cena'>
                  <p>Cijena na upit</p>
                </div>
              }
            </div>
            <div className='moji-oglasi-item-content-vreme'>
              {date ? <p>{date} <i className='ico-datum ico' /></p> : null}
              {/* <p>Broj pregleda {views} <i className='ico-novost-pregledi ico' /></p> */}
              {
                payedTo
                  ? <p className='placen-oglas-vreme'>
                    PLAĆEN do {payedTo} <i className='ico-promovisi-oglas ico' />
                  </p>
                  : null
              }
              {
                buttonsStatuses.refresh
                  ? <p>
                    {
                      this.state.secondsToRefresh <= 0
                        ? `Dostupna obnova oglasa `
                        : `Obnovi za ${this.getTimeToRefresh(this.state.secondsToRefresh)}`
                    }
                    <i className='ico-obnovi-oglas ico' />
                  </p>
                  : null
              }
            </div>
          </div>

        </div>
        <div className='moji-oglasi-item-content-akcije'>
          <div className='moji-oglasi-akcije-item'>
            {!this.props.packageExpired ? (
              <Link href={`/editAd?ad=${this.props.seo}`} as={`/profil/oglasi/izmeni/${this.props.seo}`}>
                <a><i className='ico-izmijeni-oglas ico' /> Izmijeni</a>
              </Link>
            ) : (
              <a
                href='javascript:void(0)'
                onClick={this.props.showPackageExpiredError}
              >
                <i className='ico-izmijeni-oglas ico' /> Izmijeni
              </a>
            )}
          </div>
          <Promote
            isAvailable={buttonsStatuses.promote && this.isListingStatusAllowedPromote() && !payedTo}
            adSeo={this.props.seo}
          />
          <Refresh
            isAvailable={buttonsStatuses.refresh && (this.state.secondsToRefresh <= 0) && !this.props.autoRefresh}
            adId={this.props.id} />
          <AutoRefresh adId={this.props.id} autoRefresh={this.props.autoRefresh}
            initRefresh={buttonsStatuses.refresh && (this.state.secondsToRefresh <= 0)} />
          <TogglePause
            isAvailable={buttonsStatuses.togglePause}
            adId={this.props.id}
            isPaused={this.props.status === adsStatues.PAUSED.code}
          />
          <MarkSold isAvailable={buttonsStatuses.markSold} adId={this.props.id} isPaid={this.props.isPaid} />
        </div>
        {this.props.isLoading ? <Preloader /> : null}
      </div>
    )
  }
}

Item.propTypes = {
  id: PropTypes.number.isRequired,
  category: PropTypes.shape({
    seo: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  parentCategories: PropTypes.arrayOf(PropTypes.shape({
    seo: PropTypes.string
  })),
  titleCompiled: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  isPaid: PropTypes.bool.isRequired,
  media: PropTypes.array.isRequired,
  oldPrice: PropTypes.number,
  price: PropTypes.number.isRequired,
  priceType: PropTypes.number,
  priceFrom: PropTypes.number,
  priceTo: PropTypes.number,
  priceDaily: PropTypes.number,
  priceMonthly: PropTypes.number,
  priceOnRequest: PropTypes.bool,
  priceSpecification: PropTypes.shape({
    value: PropTypes.string,
    measure: PropTypes.string
  }),
  seo: PropTypes.string.isRequired,
  // views: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({count: PropTypes.number.isRequired})), PropTypes.number]),
  listingActivated: PropTypes.string,
  listing: PropTypes.shape({
    duration: PropTypes.number.isRequired
  }),
  status: PropTypes.oneOf([
    adsStatues.PUBLISHED.code,
    adsStatues.UNPUBLISHED.code,
    adsStatues.SOLD.code,
    adsStatues.REJECTED.code,
    adsStatues.EXPIRED.code,
    adsStatues.PAUSED.code
  ]),
  isLoading: PropTypes.bool,
  isBuying: PropTypes.bool,
  refreshed: PropTypes.string,
  autoRefresh: PropTypes.bool,
  listingStatus: PropTypes.oneOf([
    listingStatuses.ACTIVE, listingStatuses.EXPIRED, listingStatuses.PENDING, listingStatuses.REJECTED, listingStatuses.STOPPED
  ]),
  thumbnail: PropTypes.shape({
    fd: PropTypes.string
  }),
  packageExpired: PropTypes.bool,
  showPackageExpiredError: PropTypes.func
}

Item.defaultProps = {
  media: []
}
